import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { Observable, throwError, EMPTY } from "rxjs";
import { catchError, map, switchMap, exhaustMap, tap } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { JSEncrypt } from 'jsencrypt';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {
  private readonly baseUnauthUrl: string = environment.baseUnauthUrl;
  private getMaintenanceDetailsAPI: string = this.baseUnauthUrl + '/maintenance/status';
  private jsEncrypt: JSEncrypt;
  accessText: string = '';

  constructor(private http: HttpClient) { 
    this.jsEncrypt = new JSEncrypt(); // You can use 1024 or 4096 too
    this.jsEncrypt.setPublicKey(environment.maintenancePublicKey);
    this.onEncrypt();
  }

  encryptData(data: string): string | false {
    return this.jsEncrypt.encrypt(data);
  }
  
  onEncrypt(): void {
    this.accessText = this.encryptData(environment.maintenanceValue) || '';
  }

  fetchSSMValues(): Observable<any> {
    return this.http.get(this.getMaintenanceDetailsAPI, {
    headers: {
      'access-key': this.accessText
    }
    });
  }
}
